import { useLang } from "@/i18n/LanguageContext";
import Reveal from "@/components/Reveal";

export default function MethodSection() {
  const { tr } = useLang();
  const m = tr("method");
  const h = tr("home");
  const steps = m.steps || [];

  return (
    <section data-testid="method-section" className="relative bg-ivory py-20 text-ink lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="mb-16 max-w-3xl">
          <Reveal>
            <p className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.25em] text-ink-muted">
              <span className="h-px w-10 bg-gold" /> {h.methodEyebrow}
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-serif text-3xl leading-tight tracking-tight sm:text-4xl lg:text-5xl">
              {h.methodTitle?.[0]}{" "}
              <em className="text-[#8a7448]">{(h.methodTitle || [])[1]}</em>
            </h2>
          </Reveal>
        </div>

        <div className="grid gap-10 md:grid-cols-5 md:gap-6 lg:gap-8">
          {steps.map((s, i) => (
            <Reveal key={s.t} delay={i * 0.09} className="relative">
              <div className="relative border-t-2 border-gold/50 pt-8">
                <span className="absolute -top-[5px] left-0 h-2 w-2 rotate-45 bg-gold" />
                <p className="font-mono text-xs tracking-[0.2em] text-ink-muted">0{i + 1}</p>
                <h3 className="mt-3 font-serif text-xl font-medium text-ink">{s.t}</h3>
                <p className="mt-3 text-sm leading-relaxed text-ink-muted">{s.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
